module.exports = __webpack_public_path__ + "static/media/plus.fd843130.svg";